import { Clock, LinearToneMapping, LoadingManager, PMREMGenerator, WebGLRenderer } from "three";
import Stats from "three/examples/jsm/libs/stats.module";
import { gsap } from "gsap";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { CameraController } from "../componets3D/CameraController";
import { sizedcanvasHome } from "../../helpers/Constnats";
import hdri from "../../assets/hdri/provence_studio_1k.hdr";
import { CharcterOxxo } from "./objects/CharacterOxxo";

import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import {
	SceneTopcOne,
	MainScene,
	SceneIntroduction,
	SceneTopicTwo,
	SceneTopicThree,
	SceneTopicFour,
	SceneTopicFive,
	SceneTopicSix,
	SceneTopicSeven,
} from "./scene";
import { sceneNumbers } from "./scene/typeScenes";
// import { GUI } from "dat.gui";
let deltasum = 0;
let interval = 1 / 60;

export class App {
	constructor(container) {
		this.container = container;
		this.loadingManager = new LoadingManager();
		this.clock = new Clock();
		this.renderer = new WebGLRenderer({ antialias: true, alpha: true });
		this.renderer.setPixelRatio(window.devicePixelRatio);
		//
		this.container.appendChild(this.renderer.domElement);
		this.camera = new CameraController(
			60,
			this.container.clientWidth / this.container.clientHeight,
			0.1,
			500,
			this.container,
			this.renderer.domElement
		);
		this.camera.position.set(-1.534, 226, 300);

		this.actualScene = 0;
		this.selectedCharacterIntroduction = {
			after: -1,
			before: -1
		}

		this.loadingHDRI();
		// * creacion de scenas para las actividades
		this.mainScene = new MainScene(this.container, this.loadingManager);
		// new SceneIntroduction(this.loadingManager, this.container, this.renderer, this.selectedCharacterIntroduction);
		this.sceneIntroduction = null
		this.sceneTopicOne = null;
		this.sceneTopicTwo = null;
		this.sceneTopicThree = null;
		this.sceneTopicFour = null;
		this.sceneTopicFive = null;
		this.sceneTopicSix = null;
		this.sceneTopicSeven = null;
		// model selected

		//
		this.stats = new Stats();
		this.stats.showPanel(0);
		this.stats.domElement.style.cssText = "position:absolute;bottom: 0;right:0px;";
		document.body.appendChild(this.stats.dom);
		//
		this.onResized();
		this.loadingProyectEvents();
		this.listenEmitters();
		window.addEventListener(
			"resize",
			() => {
				this.onResized();
				setTimeout(() => {
					this.onResized();
				}, 500);
			},
			{ passive: true }
		);
	}
	onLoadCharcater(callback) {
		if (this.characterSelected) {
			callback();
		} else {
			const loadingManagerCharacter = new LoadingManager();
			const idCharacter = parseInt(localStorage.getItem("character"));
			if (idCharacter) {
				this.characterSelected = new CharcterOxxo(loadingManagerCharacter, idCharacter, { x: -50, y: -50, z: 3.6 }, { x: 0, y: 1.4, z: 0 });
			} else {
				this.characterSelected = new CharcterOxxo(loadingManagerCharacter, 1, { x: -50, y: -50, z: 3.6 }, { x: 0, y: 1.4, z: 0 });
			}
			loadingManagerCharacter.onLoad = () => {
				callback();
			};
		}
	}

	onResized() {
		this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
		this.camera.aspect = this.container.clientWidth / this.container.clientHeight;
		this.camera.updateProjectionMatrix();
	}

	loadingHDRI() {
		const loderhdr = new RGBELoader(this.loadingManager);
		loderhdr.load(hdri, (texture) => {
			const pmremGenerator = new PMREMGenerator(this.renderer);
			var envMap = pmremGenerator.fromEquirectangular(texture).texture;

			this.environmentToScenes = envMap;

			texture.dispose();
			pmremGenerator.dispose();
		});
		this.renderer.toneMapping = LinearToneMapping;
		this.renderer.toneMappingExposure = 0.58;
		// var gui = new GUI();
		// gui.add(this.renderer, "toneMappingExposure", 0, 2).step(0.01).name("Exposure");
	}

	loadingProyectEvents() {
		// this.loadingManager.onStart = (url, itemsLoaded, itemsTotal) => {
		// 	// console.log("Started loading file: " + url + ".\nLoaded " + itemsLoaded + " of " + itemsTotal + " files.");
		// };
		// this.loadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
		// 	// const percentage = (itemsLoaded / itemsTotal) * 100;
		// };
		this.loadingManager.onLoad = () => {
			// loading complete
			this.mainScene.environment = this.environmentToScenes;
			// this.sceneIntroduction.environment = this.environmentToScenes;
			ObserverEmitter.emit(EVENTS.loadingComplete);
			this.mainScene.SceneInitialState();
			this.render();
		};
	}

	animationToRescaleRenderer(scale = 0) {
		const data = {
			iniposition: window.innerWidth,
		};
		gsap.timeline().to(data, {
			duration: 0.3,
			iniposition: window.innerWidth - scale,
			onUpdate: () => {
				this.renderer.setSize(data.iniposition, this.container.clientHeight);
				this.camera.aspect = data.iniposition / this.container.clientHeight;
				this.camera.updateProjectionMatrix();
			},
		});
	}

	listenEmitters() {
		// * move to main menu
		ObserverEmitter.on(EVENTS.back_to_main, () => {
			if (this.actualScene !== 0) {
				this.actualScene = sceneNumbers.initMainMenu
				this.animationToRescaleRenderer(sizedcanvasHome);
				this.mainScene.moveMain()
			}
		});
		ObserverEmitter.on(EVENTS.init_mainMenu, () => {
			this.actualScene = sceneNumbers.initMainMenu;
			this.animationToRescaleRenderer(sizedcanvasHome);
			this.mainScene.SceneInitialState();
		});
		// * cambio a introduccion
		ObserverEmitter.on(EVENTS.init_introduction, () => {
			this.LoadingIntroduction(() => {
				this.actualScene = sceneNumbers.initIntroduction;
				this.animationToRescaleRenderer();
				this.sceneIntroduction.SceneInitialState();
			});
		});
		// * mover a subetema 1  en activity se defini a donde se movera la camara y que estatus tendra la scena para la actividad
		ObserverEmitter.on(EVENTS.subtopicOne.initScene, (activity) => {
			this.LoadingSceneTopicOne(() => {
				this.actualScene = sceneNumbers.team1SubtopicOne;
				this.animationToRescaleRenderer();
				this.sceneTopicOne.SceneInitialState();
				this.sceneTopicOne.ActivitiSelected(activity);
			});
		});
		// subtema 2
		ObserverEmitter.on(EVENTS.subtopicTwo.initScene, (activity) => {
			this.loadingSceneTopicTwo(() => {
				this.actualScene = sceneNumbers.team1SubtopicTwo;
				this.animationToRescaleRenderer();
				this.sceneTopicTwo.SceneInitialState();
				this.sceneTopicTwo.ActivitiSelected(activity);
			});
		});
		ObserverEmitter.on(EVENTS.subtopicThree.initScene, (activity) => {
			this.loadingSceneTopicThree(() => {
				this.actualScene = sceneNumbers.team1SubtopicThree;
				this.animationToRescaleRenderer();
				this.sceneTopicThree.SceneInitialState();
				this.sceneTopicThree.ActivitiSelected(activity);
			});
		});
		ObserverEmitter.on(EVENTS.subtopicFour.initScene, (activity) => {
			this.loadingSceneTopicFour(() => {
				this.actualScene = sceneNumbers.team1SubtopicFour;
				this.animationToRescaleRenderer();
				this.sceneTopicFour.SceneInitialState();
				this.sceneTopicFour.ActivitiSelected(activity);
			});
		});
		//* Actividad 5
		ObserverEmitter.on(EVENTS.subtopicFive.initScene, (activity) => {
			this.loadingSceneTopicFive(() => {
				this.actualScene = sceneNumbers.team1SubtopicFive;
				this.animationToRescaleRenderer();
				this.sceneTopicFive.SceneInitialState();
				this.sceneTopicFive.ActivitiSelected(activity);
			});
		});
		ObserverEmitter.on(EVENTS.subtopicSix.initScene, (activity) => {
			this.loadingSceneTopicSix(() => {
				this.actualScene = sceneNumbers.team1SubtopicSix;
				this.animationToRescaleRenderer();
				this.sceneTopicSix.SceneInitialState();
				this.sceneTopicSix.ActivitiSelected(activity);
			});
		});
		ObserverEmitter.on(EVENTS.subtopicSeven.initScene, (activity) => {
			this.loadingSceneTopicSeven(() => {
				this.actualScene = sceneNumbers.team1SubtopicSeven;
				this.animationToRescaleRenderer();
				this.sceneTopicSeven.SceneInitialState();
				this.sceneTopicSeven.ActivitiSelected(activity);
			});
		});
	}

	LoadingIntroduction(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneIntroduction) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneIntroduction = new SceneIntroduction(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.selectedCharacterIntroduction,
					this.environmentToScenes,
					this.characterSelected,
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}

	LoadingSceneTopicOne(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);

		// si entro a introducion de nuevo
		if (this.selectedCharacterIntroduction.after !== -1) {
			if (this.selectedCharacterIntroduction.after !== this.selectedCharacterIntroduction.before) {
				this.selectedCharacterIntroduction.before = this.selectedCharacterIntroduction.after
				const loadingManagerCharacter = new LoadingManager();
				const idCharacter = parseInt(localStorage.getItem("character"));
				if (idCharacter) {
					this.characterSelected = new CharcterOxxo(loadingManagerCharacter, idCharacter, { x: -50, y: -50, z: 3.6 }, { x: 0, y: 1.4, z: 0 });
				} else {
					this.characterSelected = new CharcterOxxo(loadingManagerCharacter, 1, { x: -50, y: -50, z: 3.6 }, { x: 0, y: 1.4, z: 0 });
				}
				loadingManagerCharacter.onLoad = () => {
					const loadingManagerTopic = new LoadingManager();
					this.sceneTopicOne = new SceneTopcOne(
						loadingManagerTopic,
						this.container,
						this.renderer,
						this.characterSelected,
						this.environmentToScenes
					);
					loadingManagerTopic.onLoad = () => {
						ObserverEmitter.emit(EVENTS.loadingCompleteScene);
						callback();
					};
				};
				return
			}
		}

		//normal
		if (this.sceneTopicOne) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTopicOne = new SceneTopcOne(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}

	loadingSceneTopicTwo(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTopicTwo) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTopicTwo = new SceneTopicTwo(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);

					callback();
				};
			});
		}
	}
	loadingSceneTopicThree(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTopicThree) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTopicThree = new SceneTopicThree(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);

					callback();
				};
			});
		}
	}

	loadingSceneTopicFour(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTopicFour) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTopicFour = new SceneTopicFour(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}
	loadingSceneTopicFive(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTopicFive) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTopicFive = new SceneTopicFive(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}
	loadingSceneTopicSix(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTopicSix) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTopicSix = new SceneTopicSix(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}
	loadingSceneTopicSeven(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTopicSeven) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTopicSeven = new SceneTopicSeven(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}

	render() {
		const delta = this.clock.getDelta();
		deltasum += delta;

		// requestAnimationFrame(this.render);
		if (deltasum > interval) {
			let sceneToRender;

			switch (this.actualScene) {
				case sceneNumbers.initMainMenu:
					sceneToRender = this.mainScene;
					break;
				case sceneNumbers.initIntroduction:
					sceneToRender = this.sceneIntroduction;
					break;
				case sceneNumbers.team1SubtopicOne:
					sceneToRender = this.sceneTopicOne;
					break;
				case sceneNumbers.team1SubtopicTwo:
					sceneToRender = this.sceneTopicTwo;
					break;
				case sceneNumbers.team1SubtopicThree:
					sceneToRender = this.sceneTopicThree;
					break;
				case sceneNumbers.team1SubtopicFour:
					sceneToRender = this.sceneTopicFour;
					break;
				case sceneNumbers.team1SubtopicFive:
					sceneToRender = this.sceneTopicFive;
					break;
				case sceneNumbers.team1SubtopicSix:
					sceneToRender = this.sceneTopicSix;
					break;
				case sceneNumbers.team1SubtopicSeven:
					sceneToRender = this.sceneTopicSeven;
					break;
				default:
					sceneToRender = this.mainScene;
					break;
			}

			// console.log(this.actualScene);

			this.renderer.render(sceneToRender, this.camera);
			sceneToRender.renderAnimations(deltasum);
			this.camera.update(deltasum);

			if (this.characterSelected) {
				// this.characterSelected.renderAnimations(deltasum, this.camera);
				this.characterSelected.renderAnimations(deltasum, null);
			}

			this.stats.update();

			deltasum = deltasum % interval;
		}
		requestAnimationFrame(() => this.render());
	}
}
